import { gql } from "@apollo/client";

export const GET_TICKETING_QUERY = gql`
 query Tickets {
    tickets(status: null, category: null) {
        id
        short_code
        parent_ticket
        company_id
        created_by
        title
        description
        priority
        category
        sub_category
        status
        estimated_time
        start_date
        end_date
        assigned_to {
            id
            firstName
            lastName
            fullName
        }
        assigned_by {
            id
            firstName
            lastName
            fullName
        }
        assigned_at
        resolved_at
        closed_at
        created_at
        updated_at
        deleted_at
        ticketComments {
            count
        }
    }
}
`;

export const GET_TICKET_COMMENTS_QUERY = gql`
  query TicketComments($ticket_id: ID!) {
    ticketComments(ticket_id: $ticket_id) {
      id
      ticket_id
      user_id
      user_schema
      user_name
      user_email
      comment
      created_at
      updated_at
      deleted_at
    }
  }
`;
